import './CssLoader.scss'

function CssLoader() {
  return (
    <div className="loader-container">
        <span class="loader"></span> 
    </div>
  )
}

export default CssLoader